module.exports = __webpack_public_path__ + "img/faq.cfd22004.svg";